import React from 'react';

const RedDownArrowIcon = () => {
    return (
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="4.39075" y1="3.52094" x2="11.0129" y2="10.0562" stroke="url(#paint0_linear_3721_30327)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.9859 5.47113L12.0221 10.961L6.51959 10.9973" stroke="url(#paint1_linear_3721_30327)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3721_30327" x1="2.41165" y1="2.97278" x2="7.34556" y2="13.6038" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2547D" />
                    <stop offset="1" stopColor="#FF7959" />
                </linearGradient>
                <linearGradient id="paint1_linear_3721_30327" x1="11.785" y1="5.27295" x2="14.7994" y2="8.34778" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2547D" />
                    <stop offset="1" stopColor="#FF7959" />
                </linearGradient>
            </defs>
        </svg>

    )
}

export default RedDownArrowIcon;